import React from 'react';
import { Box, Typography, Grid2, Paper, Button, useTheme, Icon } from '@mui/material';
import Section from './Section';

const SeccionRegistro = () => {
  const theme = useTheme();

  const registrationSteps = [
    'Introduce tu nombre y apellido',
    'Proporciona un correo electrónico válido',
    'Selecciona el código de área de tu país',
    'Escribe tu número de teléfono',
    'Crea una contraseña segura',
    'Confirma tu contraseña',
    'Acepta las políticas de privacidad y términos de uso',
  ];

  return (
    <Section
      title="¿Cómo Registrarse?"
      subtitle="Crear tu cuenta es rápido y 100% gratuito. Solo sigue estos sencillos pasos desde la app móvil:"
      hasBackground={false}
      id="registro"
    >
      <Grid2 container spacing={4} alignItems="center">
        {/* Lista de pasos */}
        <Grid2 size={{ xs: 12, md: 7 }}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 2.5, sm: 3.5 },
              borderRadius: '16px',
              bgcolor: theme.palette.background.paper,
              border: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid rgba(45, 52, 132, 0.08)',
              boxShadow: theme.palette.mode === 'dark' ? '0 4px 20px rgba(0, 0, 0, 0.4)' : '0 4px 16px rgba(26, 31, 82, 0.04)',
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 800, mb: 2.5, color: theme.palette.text.primary }}>
              Pasos para crear tu cuenta
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              {registrationSteps.map((step, index) => (
                <Box
                  key={index}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.8,
                    p: 1.4,
                    borderRadius: '12px',
                    bgcolor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.03)' : '#ffffff',
                    border: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.06)' : '1px solid rgba(0, 0, 0, 0.06)',
                    boxShadow: theme.palette.mode === 'dark' ? 'none' : '0 2px 6px rgba(26, 31, 82, 0.03)',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      borderColor: theme.palette.mode === 'dark' ? 'rgba(99, 102, 241, 0.4)' : 'rgba(45, 52, 132, 0.2)',
                      transform: 'translateX(2px)',
                    },
                  }}
                >
                  {/* Badge numerado idéntico a rauh-rifas */}
                  <Box
                    sx={{
                      width: 28,
                      height: 28,
                      fontSize: '0.85rem',
                      fontWeight: 900,
                      bgcolor: theme.palette.mode === 'dark' ? 'rgba(99, 102, 241, 0.16)' : 'rgba(45, 52, 132, 0.08)',
                      color: theme.palette.mode === 'dark' ? '#818cf8' : theme.palette.primary.main,
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}
                  >
                    {index + 1}
                  </Box>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.text.primary }}>
                    {step}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Paper>
        </Grid2>

        {/* Video Tutorial Card */}
        <Grid2 size={{ xs: 12, md: 5 }}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 3, sm: 4 },
              borderRadius: '16px',
              bgcolor: theme.palette.background.paper,
              border: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid rgba(45, 52, 132, 0.1)',
              textAlign: 'center',
              boxShadow: theme.palette.mode === 'dark' ? '0 4px 20px rgba(0, 0, 0, 0.4)' : '0 4px 16px rgba(26, 31, 82, 0.04)',
            }}
          >
            <Box
              sx={{
                width: 52,
                height: 52,
                mx: 'auto',
                mb: 2,
                borderRadius: '12px',
                bgcolor: 'rgba(241, 91, 40, 0.08)',
                color: theme.palette.secondary.main,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Icon sx={{ fontSize: 28, color: theme.palette.secondary.main }}>smart_display</Icon>
            </Box>

            <Typography variant="h6" sx={{ fontWeight: 800, mb: 1, color: theme.palette.text.primary }}>
              ¿Prefieres ver el Tutorial?
            </Typography>

            <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 3, lineHeight: 1.6 }}>
              Aprende paso a paso en este video corto cómo registrarte y activar tu cuenta en menos de un minuto.
            </Typography>

            <Button
              variant="outlined"
              color="secondary"
              size="large"
              fullWidth
              startIcon={<Icon>play_arrow</Icon>}
              href="https://youtube.com/shorts/D4VjVRXCl9o?si=ijYHr8Qi1UYbrMau"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                py: 1.2,
                fontWeight: 800,
                borderRadius: '8px',
                borderWidth: '1.5px',
                '&:hover': {
                  borderWidth: '1.5px',
                  bgcolor: 'rgba(241, 91, 40, 0.06)',
                },
              }}
            >
              Ver Tutorial en YouTube
            </Button>
          </Paper>
        </Grid2>
      </Grid2>
    </Section>
  );
};

export default SeccionRegistro;